import { Modal } from "@components/modal";
import { Panel, PanelBody, PanelHeader, PanelTitle, PanelTitleArea } from "@components/panel";
import { FC } from "react";
import { ShareForm } from "./share-form";

interface ShareFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  appId?: string;
  formId?: string;
}
const ShareFormDialog: FC<ShareFormDialogProps> = ({ isOpen, onClose, appId, formId }) => {
  return (
    <>
      <Modal isOpen={isOpen} placement="center" onClose={onClose}>
        <Panel className="share-dialog">
          <PanelHeader>
            <PanelTitleArea>
              <PanelTitle>Privacy Settings</PanelTitle>
            </PanelTitleArea>
          </PanelHeader>
          <PanelBody>
            <ShareForm appId={appId} formId={formId} />
          </PanelBody>
        </Panel>
      </Modal>
    </>
  );
};

export default ShareFormDialog;
